import React from "react";
import { Chip } from "@mui/material";
import { STATUS_COLORS } from "../../types";

interface StatusBadgeProps {
  status: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const colors = STATUS_COLORS[status] || { bg: "#e2e8f0", text: "#475569" };
  return (
    <Chip
      label={status}
      size="small"
      sx={{
        height: 22,
        fontSize: 11,
        fontWeight: 600,
        borderRadius: "99px",
        background: colors.bg,
        color: colors.text,
        "& .MuiChip-label": { px: 1.2, py: 0 },
      }}
    />
  );
};

export default StatusBadge;
